import styled  from 'styled-components';

import { buttonHoverEffect } from '../../../Teachers/TeacherMenu.styles'

export const Grid = styled.div`
    display: grid;
    grid-template-columns: repeat(2, 400px);
    grid-auto-rows: 460px;
    grid-gap: 3em;
    margin: 3em 0 5em 0;
`

export const GridItem = styled.div`
    width: 400px;
    height: 460px;
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: 1fr;
    grid-template-areas: "tile";
    /* place-items: center; */
    justify-content: center;
    overflow: hidden;
    border: 2px solid ${props => props.highlightColor ? props.highlightColor : '#acff24'};
    color: #fff;
    background-color: #666666;

       .bg-holder {
           display: flex;
           align-items: center;
           justify-content: center;
        grid-area: tile;
        width: calc(100% - 50px);
        height: 210px;
        z-index: 0;
        /* background-image: url(${props => props.backgroundImage}); */
        /* background-size: contain; */
        background-color: #000;
        justify-self: center;
        margin-top: 20px;
        border-radius: 5px;

        img {width: 90%; height: auto;}
    }

        .grid-item-content {
            grid-area: tile;
            width: 100%;
            height: 100%;
            background-color: #000000a1;
            padding: 32px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            align-items: center;
            z-index: 0;

           .play-icon {
            height: 200px;
            display: flex;
            place-items: center;

                i.play-vid {
                font-size: 80px;
                cursor: pointer;
            }
           }
        }



        h3.report-title {
            font: italic bold 20px "Roboto Condensed";
            text-transform: uppercase;
            text-align: center;
        }

        p.report-description {
            text-align: center;
            color: #fff;
            font-style: italic;
            font-size: 14px;
        }

           button.download-report {
        font: italic bold 16px 'Roboto Condensed';
        padding: .25em 1.5em;
        border: 1px solid ${props => props.highlightColor};
        background: transparent;
        color: #fff;
        width: 146px;height: 34px;
        position: relative;
        z-index: 2;
    }

   button.download-report::before {
        content: '';
        width: 0;
        height: 100%;
        position: absolute;
        background-color: ${props => props.highlightColor};
        top: 0; left: 0;
        z-index: -1;
    }

   button.download-report:hover {color: black;}


   button.download-report:hover::before {
        animation: ${buttonHoverEffect} 0.6s ease;
        animation-fill-mode: forwards;
    }
`

export const ModalWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: #1a1a1a;
    padding: 20px;
    width: 100%;
    height: 100%;


    i {
        align-self: flex-end;
        color: #acff24;
        font-size: 32px;
        transition: all 300ms ease;
        cursor: pointer;
        margin-bottom: 16px;

        :hover {color: #ff0033; transform: scale(1.125); transition: all 300ms ease;}
    }
`




// WEBPACK FOOTER //
// ./src/pages/DataCenter/School/ReportCenter/ReportCenter.styles.ts